import { FaustProvider } from '@faustwp/core';
import { AppProps } from 'next/app';
import { Inter } from 'next/font/google';
import { useRouter } from 'next/router';

import '../../faust.config';

import HeaderProvider from '../layout/Header/state/HeaderProvider';
import AppScripts from '../services/AppScripts';

import '../styles/globals.css';

const inter = Inter({ subsets: ['latin'] });

// eslint-disable-next-line @typescript-eslint/naming-convention
const MyApp = ({ Component, pageProps }: AppProps) => {
  const router = useRouter();

  return (
    <HeaderProvider>
      {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment*/}
      <FaustProvider pageProps={pageProps}>
        <style
          global
          jsx
        >
          {`
          html {
            font-family: ${inter.style.fontFamily};
          }
        `}
        </style>
        {/* eslint-disable-next-line @stylistic/max-len */}
        {/* https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/Heading_Elements#specifying_a_uniform_font_size_for_h1 */}
        <style
          global
          jsx
        >
          {`
          :where(h1) {
            margin-block: 0.67em;
            font-size: 2em;
          }
        `}
        </style>
        <Component
          {...pageProps}
          key={router.asPath.split('?')[0]}
        />

        <AppScripts />
      </FaustProvider>
    </HeaderProvider>
  );
};

export default MyApp;
